import { useEffect } from 'react';

import { EVENT_THEMATIC_LINK } from './useLinkProps';

export const useThematicLink = (callback: { (key: string, description: string): void }): void => {
  useEffect(() => {
    const handle = (event) => {
      const {
        detail: { key, description },
      } = event;
      callback(key, description);
    };
    document.addEventListener(EVENT_THEMATIC_LINK, handle);
    return () => {
      document.removeEventListener(EVENT_THEMATIC_LINK, handle);
    };
  }, [callback]);
};
